import { render, staticRenderFns } from "./RSearchInput.vue?vue&type=template&id=4b3e8f56&scoped=true&"
import script from "./RSearchInput.vue?vue&type=script&lang=js&"
export * from "./RSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./RSearchInput.vue?vue&type=style&index=0&id=4b3e8f56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3e8f56",
  null
  
)

export default component.exports